import { render } from "./MyPagesMenuOrganizationSwitcher.vue?vue&type=template&id=f1ae395e"
import script from "./MyPagesMenuOrganizationSwitcher.vue?vue&type=script&lang=js"
export * from "./MyPagesMenuOrganizationSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__